import { render } from "./BasicRight.vue?vue&type=template&id=5f7114da&scoped=true"
import script from "./BasicRight.vue?vue&type=script&lang=js"
export * from "./BasicRight.vue?vue&type=script&lang=js"

import "./BasicRight.vue?vue&type=style&index=0&id=5f7114da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7114da"]])

export default __exports__